import { Skeleton, Space } from "antd";
import React from "react";

const JobCardLoader: React.FC = () => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 8,
        }}
      >
        <Skeleton.Input style={{ borderRadius: 8 }} active size="small" />
        <Space align="center">
          <Skeleton.Button style={{ width: 80 }} active size="small" />
          <Skeleton.Button style={{ width: 80 }} active size="small" />
        </Space>
      </div>
      <div style={{ marginBottom: 8 }}>
        <Skeleton.Input style={{ width: 200 }} active size="default" />
      </div>
      <Skeleton active title={false} paragraph={{ rows: 2 }} />
    </div>
  );
};

export default JobCardLoader;
